import actionCreatorFactory from 'typescript-fsa';
import { ApiBase } from '../../../../service/api-base';
import { CsvNotOrderType } from '../../../../type/csv/csv.type';

/* Param */
export type ApiCsvNonOrderGetListParam = Partial<{
  /** 最終見積作成日（開始） */
  estimate_dt_from: string;
  /** 最終見積作成日（終了） */
  estimate_dt_to: string;
  /** 最終見積金額（最小値） */
  estimate_kin_min: number;
  /** 最終見積金額（最大値） */
  estimate_kin_max: number;
  /** 粗利 */
  margin_ritu: string;
  /** 粗利フィルタ */
  margin_ritu_filter: number;
  /** 部位 */
  construction_parts: number[];
  /** 契約フラグ */
  contract_flag: number;
  /** 案件担当（店舗） */
  project_store_id: number;
  /** 案件担当（担当者） */
  project_employee_id: number;
  /** 顧客名 */
  customer_name: string;
  /** 案件名 */
  name: string;
  /** 現場名称 */
  field_name: string;
  /** 現場電話番号 */
  field_tel_no: string;
  /** オフセット */
  offset: number;
  /** 1ページ内の件数 */
  limit: number;
  /** 並替基準列 */
  sort_by: number;
  /** 並替方法 */
  highlow: number;
  /** 登録店舗 */
  created_store_id:number;
  /** 登録社員 */
  created_employee_id:number;
  /** 更新店舗 */
  updated_store_id:number;
  /** 更新社員 */
  updated_employee_id:number;
  /** 登録日－期間開始 */
  created_at_start:string;
  /** 登録日－期間終了 */
  created_at_end:string;
  /** 更新日－期間開始 */
  updated_at_start:string;
  /** 更新日－期間終了 */
  updated_at_end:string;
}>;

export type ApiCsvNonOrderDownloadParam = any;

/* Response */
export type ApiCsvNonOrderGetListResponse = CsvNotOrderType;

export const ActionCreator = actionCreatorFactory('csv/api/non/order');

export const apiCsvNonOrder = {
  getList: ActionCreator<ApiCsvNonOrderGetListParam>('get/list'),
  download: ActionCreator<ApiCsvNonOrderDownloadParam>('download'),
};

export class ApiCsvNonOrderGetList extends ApiBase<ApiCsvNonOrderGetListResponse> {
  constructor(param: ApiCsvNonOrderGetListParam) {
    super({
      httpMethod: 'GET',
      param,
      url: '/api/csv/notorder',
    });
  }
}

export class ApiCsvNonOrderDownload extends ApiBase {
  constructor(param: ApiCsvNonOrderDownloadParam) {
    super({
      httpMethod: 'GET',
      contents: 'BLOB',
      param,
      url: '/api/csv/download/notorder',
    });
  }
}
